import { useEffect } from 'react';
import { businessEntity, websiteEntity, injectJsonLd, setHeadMeta, canonicalUrl, BUSINESS_ID, WEBSITE_ID, SITE_URL } from '../utils/seo';

interface PageMetaOptions {
  title: string;
  description: string;
  path: string;
  /** Visible page name used as the last breadcrumb. Omit on the homepage. */
  breadcrumbName?: string;
  /** Additional schema nodes specific to this page. */
  extraGraph?: object[];
}

/**
 * Per-route head tags plus one linked JSON-LD graph (business, website,
 * this web page, and an optional breadcrumb trail).
 */
export function usePageMeta({
  title,
  description,
  path,
  breadcrumbName,
  extraGraph = []
}: PageMetaOptions) {
  useEffect(() => {
    setHeadMeta({
      title,
      description,
      path
    });
    const url = canonicalUrl(path);
    const graph: object[] = [businessEntity, websiteEntity, {
      '@type': 'WebPage',
      '@id': `${url}#webpage`,
      url,
      name: title,
      description,
      isPartOf: {
        '@id': WEBSITE_ID
      },
      about: {
        '@id': BUSINESS_ID
      }
    }, ...extraGraph];
    if (breadcrumbName) {
      graph.push({
        '@type': 'BreadcrumbList',
        '@id': `${url}#breadcrumb`,
        itemListElement: [{
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: `${SITE_URL}/`
        }, {
          '@type': 'ListItem',
          position: 2,
          name: breadcrumbName,
          item: url
        }]
      });
    }
    return injectJsonLd(graph);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);
}
